export function listenMediaQuery(query, callback) {
  if (!query) return () => {};
  if (typeof query.addEventListener === 'function') {
    query.addEventListener('change', callback);
    return () => { if (typeof query.removeEventListener === 'function') query.removeEventListener('change', callback); };
  }
  // Старые Safari/iOS используют API MediaQueryList до EventTarget.
  if (typeof query.addListener === 'function') {
    query.addListener(callback);
    return () => { if (typeof query.removeListener === 'function') query.removeListener(callback); };
  }
  return () => {};
}